'use es6';

import isTestPage from './utils/isTestPage';
import { bestContrastColor } from './utils/bestContrastColor';
const findAndRemoveLoadingContainer = () => {
  const loadingContainer = document.querySelector('#loading__container');
  if (loadingContainer) {
    loadingContainer.parentNode.removeChild(loadingContainer);
  }
};
(function (formsReadyQueue) {
  const setupTestPage = () => {
    document.querySelector('.hs-form').classList.add('is-test');
    window.HubSpotForms.currentForm.setContext({
      isTestPage: true
    });
  };
  const start = () => {
    window.HubSpotForms.currentForm.on('onFormDefinitionFetchSuccess', result => {
      const {
        form: {
          themeColor
        } = {}
      } = result;
      const style = document.createElement('style');
      document.head.append(style);
      style.textContent = `
        .hs-form__actions__submit {
          border-color: ${themeColor};
          color: ${bestContrastColor(themeColor)};
        }
      `;
    });
    window.HubSpotForms.currentForm.on('onPageChange', () => {
      try {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } catch (e) {
        window.scrollTo(0, 0);
      }
    });
  };
  function listenForFormReady() {
    window.HubSpotForms.onFormReady(() => {
      start();
      if (isTestPage()) {
        setupTestPage();
      }
      findAndRemoveLoadingContainer();
    });
  }
  if (window.HubSpotForms) {
    listenForFormReady();
  }
  formsReadyQueue.push(listenForFormReady);
})(window.hsFormsOnReady);